import { FC, ReactNode, useCallback, useMemo } from 'react';
import { WalletAdapterNetwork, WalletError } from '@solana/wallet-adapter-base';
import { ConnectionProvider, WalletProvider } from '@solana/wallet-adapter-react';
// import { WalletModalProvider as ReactUIWalletModalProvider } from '../../utils/wallet-adapter-react-ui';
import { WalletModalProvider as ReactUIWalletModalProvider } from '@solana/wallet-adapter-react-ui';

require('@solana/wallet-adapter-react-ui/styles.css');


const WalletContextProvider = ({ children }) => {
    const network = process.env.REACT_APP_WALLET_ADAPTER_NETWORK == 'dev' ? WalletAdapterNetwork.Devnet : WalletAdapterNetwork.Mainnet;
    //quicknode hopefully works better
    //const endpoint = useMemo(() => "https://spring-frosty-snowflake.solana-mainnet.discover.quiknode.pro/5584f3ace79637af8f83a6f135554af9e0f0ffca/", [network]);
    
    const endpoint = useMemo(() => process.env.REACT_APP_RPC_URL, [network]);
    let wallets = useMemo(
        () => [ ],
        [network]
    );
    const onError = useCallback(
        (error) => {
            console.error(error);
        },
        []
    );
    return (
        <ConnectionProvider endpoint={endpoint}>
            <WalletProvider wallets={
                wallets.filter(wallet => {
                    return wallet.readyState === "Installed"}
                )} onError={onError} autoConnect>
                <ReactUIWalletModalProvider>{children}</ReactUIWalletModalProvider>
            </WalletProvider>
        </ConnectionProvider>
    );
};

export default WalletContextProvider;